import(/* webpackMode: "eager" */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\src\\app\\food-jar\\page.tsx");
